import React, { useState } from 'react';

const faqs = [
    {
        question: 'What age groups are eligible for NexGen Learning programs?',
        answer: 'Our programs are designed for children aged 6 to 16 years. We have different curriculum tracks tailored to different age groups to ensure age-appropriate learning and engagement.'
    },
    {
        question: 'Do you offer certificates upon completion?',
        answer: 'Yes, we provide course completion certificates for all our programs. These certificates are recognized by educational institutions and can be a valuable addition to your child\'s portfolio.'
    },
    {
        question: 'What is the class schedule and duration?',
        answer: 'Classes are typically 60 minutes long, scheduled 2-3 times per week. We offer flexible timing slots to accommodate different time zones and schedules. You can choose the timing that works best for your child.'
    },
    {
        question: 'What equipment do students need?',
        answer: 'Students need a computer or laptop with a stable internet connection, a webcam, and a microphone. For specific programs like robotics, we provide a list of required materials that are easily accessible.'
    },
    {
        question: 'How do you ensure student progress?',
        answer: 'We track progress through regular assessments, project submissions, and one-on-one feedback sessions. Parents receive detailed progress reports and can schedule meetings with instructors to discuss their child\'s development.'
    }
];

const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    return (
        <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Frequently Asked <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">Questions</span>
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Find answers to common questions about our programs and learning approach
                    </p>
                </div>

                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300"
                        >
                            <button
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                className="w-full px-6 py-4 text-left focus:outline-none"
                            >
                                <div className="flex items-center justify-between">
                                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                                    <svg
                                        className={`w-6 h-6 text-gray-500 transform transition-transform duration-200 ${
                                            openIndex === index ? 'rotate-180' : ''
                                        }`}
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M19 9l-7 7-7-7"
                                        />
                                    </svg>
                                </div>
                            </button>
                            <div
                                className={`px-6 transition-all duration-300 ease-in-out ${
                                    openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'
                                }`}
                            >
                                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-12 text-center">
                    <p className="text-gray-600 mb-4">Still have questions?</p>
                    <button className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-lg font-semibold rounded-full hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200">
                        Contact Us
                        <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                        </svg>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;